module.exports = __webpack_public_path__ + "static/media/mon-mothma.3e731ffc.jpg";